import { SharedModuleConfig } from "./shared-module-config";
import { PasswordValidatorOptions } from "../validators/password-validator";

export abstract class AuthenticationConfig extends SharedModuleConfig {
  theme?: 'tngh' | 'mdef' | 'cvte' | 'wnt' = 'tngh';
  passwordValidationOptions?: PasswordValidatorOptions = {minLength: 12}
}
